// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonAppHelp_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 0H21V6V10V11.8559C20.3671 11.6495 19.696 11.5278 19 11.5042V10.252V6V2H5V18H11.5383C11.513 18.2465 11.5 18.4968 11.5 18.75C11.5 19.1763 11.5368 19.5939 11.6074 20H11C10.4477 20 10 20.4477 10 21C10 21.5523 10.4477 22 11 22H12.2675C12.6445 22.7505 13.148 23.4265 13.75 24H3V0ZM24 18.75C24 21.6495 21.6495 24 18.75 24C15.8505 24 13.5 21.6495 13.5 18.75C13.5 15.8505 15.8505 13.5 18.75 13.5C21.6495 13.5 24 15.8505 24 18.75ZM21.5501 16.9687C21.5501 15.6052 20.2832 14.5 18.7207 14.5C17.356 14.5 16.2162 15.3435 15.95 16.4659L17.5642 16.9687C17.5642 16.4122 18.0835 15.9597 18.7206 15.9597C19.3582 15.9597 19.8769 16.4122 19.8769 16.9687C19.8769 17.3444 19.6396 17.673 19.2894 17.8464C18.7359 18.1279 18.3031 18.5696 18.0706 19.0971C17.992 19.2769 17.9368 19.4661 17.9079 19.663H17.9093V20.1002H19.6191V19.663H19.616C19.7079 19.4209 19.9022 19.2194 20.1544 19.0971H20.1527C20.9891 18.6686 21.5501 17.876 21.5501 16.9687ZM19.6834 21.0336H17.8167V22.9003H19.6834V21.0336Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonAppHelp is a generated icon component.
 */
let IconCommonAppHelp = IconCommonAppHelp_1 = class IconCommonAppHelp extends IconBaseElement {
    render() {
        return html `${IconCommonAppHelp_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonAppHelp.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonAppHelp = IconCommonAppHelp_1 = __decorate([
    customElement('zui-icon-common-app-help')
], IconCommonAppHelp);
export { IconCommonAppHelp };
